import React from 'react';
import { Navbar, FooterOverlay, Bookings } from '../../components';

const Reservation = () => {
  return (
    <div style={{ backgroundColor: 'var(--color-cream)', minHeight: '100vh' }}>
      <Navbar />
      <Bookings />
      <FooterOverlay />
    </div>
  );
};

export default Reservation;
